/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_Tasks_TitleInputs */

const en_mk_preview_tasks_title = /** @type {(inputs: Mk_Preview_Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every task, with progress you can follow.`)
};

const id_mk_preview_tasks_title = /** @type {(inputs: Mk_Preview_Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap tugas, jelas kemajuannya.`)
};

/**
* | output |
* | --- |
* | "Every task, with progress you can follow." |
*
* @param {Mk_Preview_Tasks_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_tasks_title = /** @type {((inputs?: Mk_Preview_Tasks_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_Tasks_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_tasks_title(inputs)
	return en_mk_preview_tasks_title(inputs)
});